import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SettingsService } from 'lib-shared';
import { HttpClient } from '@angular/common/http';
import { ControllerApiList } from '../../models/controllers/ControllerList';
import { isPlatformBrowser } from '@angular/common';

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ConversionApiService {
  private isBrowser: boolean;

  constructor(
    private http: HttpClient,
    private settings: SettingsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  trackEvent(
    eventName: string,
    email?: string,
    phone?: string,
    price?: number
  ) {
    if (!this.isBrowser) return;

    // Get cookie values
    const fbp = this.getCookie('_fbp') || '';
    const fbc = this.getCookie('_fbc') || '';

    // Trigger Meta Pixel event
    if (window.fbq) {
      window.fbq('track', eventName);
    }

    // Prepare payload
    const payload = {
      EventName: eventName,
      Email: email || '',
      Phone: phone || '',
      FBC: fbc,
      FBP: fbp,
      ...(eventName === 'Purchase' && price ? { Price: price } : {}), // Only include Price for Purchase events
    };

    // Determine the endpoint based on event type
    const endpoint =
      eventName === 'Purchase'
        ? ControllerApiList.HubApi.ConversionAPIPurchase
        : ControllerApiList.HubApi.ConversionAPI;

    this.http
      .post(`${this.settings.getHubBaseUrlApi}/${endpoint}`, payload)
      .subscribe({
        next: (res) => console.log(`Event ${eventName} correctly sent`, res),
        error: (err) => console.error(`Error sending event ${eventName}`, err),
      });
  }

  private getCookie(name: string): string | null {
    if (!this.isBrowser) return null;
    
    const match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? match[2] : null;
  }
}
